module.exports = __webpack_public_path__ + "static/media/l_citizencan_logo_blanc.a3adaed6.svg";